// 收银台
const Config = {
  'cashier.pay_confirm': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'pay_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData, type) {
        const { u, selectedBank, selectedInstallment, selectedCreditCard, orderId } = traceData;
        let paymethod = `${selectedBank}`;
        if (selectedCreditCard) {
          paymethod = selectedCreditCard.toLowerCase();
          if (selectedInstallment) {
            const { stage } = selectedInstallment;
            paymethod += '_' + stage;
          }
        }
        if (type === 'touch') {
          return { u, paymethod, order_id: orderId };
        }
        return { order_id: orderId };
      },
    },
  },
  'cashier.allorders': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'allorders',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData, type) {
        return { u: traceData.u };
      },
    },
  },
  'cashier.pay': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'variable',
      func: function getC(traceData) {
        const { c } = traceData;
        // 云闪付分期，产品不想用服务端给的bank名称，需要单独判断，换一个
        return c === 'UPQUICKPASS' ? 'cloud_quickpass_Install' : c;
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData, type) {
        let { c, u, lable, tags, selectedCreditCard, selectedInstallment, creditCardInstallments } = traceData;
        if (c === 'creditcardinstal' && type === 'touch') {
          if (!selectedCreditCard) {
            selectedCreditCard = creditCardInstallments[0].code;
          }
          const { stage } = selectedInstallment;
          return { u, lable, tags, paymethod: selectedCreditCard.toLowerCase() + '_' + stage };
        }

        return { u, lable, tags };
      },
    },
  },
  'cashier.fail_toast': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'fail_toast',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return traceData;
      },
    },
  },

  'cashier.credit': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'variable',
      func: function getC(traceData) {
        return traceData.c;
      },
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'cashier.instal': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'variable',
      func: function getC(traceData) {
        return traceData.c;
      },
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'cashier.paymethod_more': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'paymethod_more',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid() {
        return { status: 1 };
      },
    },
  },
  'cashier.cancel_dialog_pop': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'cancel_dialog_pop',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'cashier.pay_exclamation_dialog': {
    operation: ['VISIBLE', 'TOUCH'],
    c: {
      type: 'constant',
      value: 'pay_exclamation_dialog',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { paymethod } = traceData;
        return { paymethod };
      },
    },
  },
  'cashier.cancel_confirm': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'cancel_confirm',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        const { u } = traceData;
        return { u };
      },
    },
  },
  'cashier.cancel_continue': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'cancel_continue',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
};

export default Config;
